/**
 * ...
 * @author Robert Lombardo, Wakefield Studios ( rob@wakefield-studios.com )
 */
const MoveDecision = require('./MoveDecision');
const BattleCalc = require('../../BattleCalc');

const MoveAwayDecision = function (actor, battleState) {
  const node = new MoveDecision(actor, battleState);
  node.is_move_away = true;

  node.getTargetTile = function (move_away_input, candidate_tiles) {
    // filter candidates for closest to the target
    let farthest_dist = 0;
    for (const tile of candidate_tiles) {
      const dist = BattleCalc.boardDistance(tile, move_away_input);
      if (dist > farthest_dist) farthest_dist = dist;
    }
    let final_candidate_tiles = candidate_tiles.filter(
      (tile) =>
        BattleCalc.boardDistance(tile, move_away_input) === farthest_dist
    );

    // filter again for closest to actor
    let closest_to_actor_dist = Infinity;
    for (const tile of final_candidate_tiles) {
      const dist = BattleCalc.boardDistance(tile, actor);
      if (dist < closest_to_actor_dist) closest_to_actor_dist = dist;
    }
    final_candidate_tiles = final_candidate_tiles.filter(
      (tile) => BattleCalc.boardDistance(tile, actor) === closest_to_actor_dist
    );

    // get a random tile among final candidates
    return final_candidate_tiles[
      Math.floor(Math.random() * final_candidate_tiles.length)
    ];
  };

  return node;
};
module.exports = MoveAwayDecision;
